import {NumberUtil, RestClient} from "zavadil-ts-common";
import {User, UserData} from "../../types/User";

export class UsersClient {

	client: RestClient;

	constructor(client: RestClient) {
		this.client = client;
	}

	profile(): Promise<User> {
		return this.client.getJson('users/profile');
	}

	all(): Promise<Array<User>> {
		return this.client.getJson('users/all');
	}

	load(id: number): Promise<User> {
		return this.client.getJson(`users/${id}`);
	}

	save(user: UserData): Promise<User> {
		return NumberUtil.isEmpty(user.id)
			? this.client.postJson('users', user)
			: this.client.putJson(`users/${user.id}`, user);
	}

	changeMyPassword(password: string): Promise<any> {
		return this.client.put('users/profile/password', password);
	}

	changePassword(userId: number, password: string): Promise<any> {
		return this.client.put(`users/${userId}/password`, password);
	}

}
